import {ReactElement} from "react"
import {useTranslate} from "@refinedev/core"
import {Col, Collapse, FormInstance} from "antd"
import {Checkbox} from "antd/lib"
import IClient from "../../interfaces/IClient"
import ConfigItac from "../clientsConfigs/ConfigItac"
import ConfigLA3d from "../clientsConfigs/ConfigLA3d"
import ConfigLAScholar from "../clientsConfigs/ConfigLAScholar"
import ConfigLAVirtualLabs from "../clientsConfigs/ConfigLAVirtualLabs"
import ConfigLAWeb from "../clientsConfigs/ConfigLAWeb"
import {Custom} from "../../utils/refineUtils"

interface IProps {
    client: IClient
    config?: any
    form?: FormInstance<{}>
    editable?: boolean
    index?: number
    span?: number
    checked?: boolean
    onChange?: (client: IClient) => void
}

export default function ClientCard(props: IProps): ReactElement | null {
    const translate = useTranslate()
    const handleCheckboxChange = () => props?.onChange && props.onChange(props?.client)
    const config: any = {
        'itac': (props: IProps) => <ConfigItac {...props}/>,
        'la3d': (props: IProps) => <ConfigLA3d {...props}/>,
        'las': (props: IProps) => <ConfigLAScholar {...props}/>,
        'lavl': (props: IProps) => <ConfigLAVirtualLabs {...props}/>,
        'laweb': (props: IProps) => <ConfigLAWeb {...props}/>
    }

    return (
        props.client && <Col span={props.span ?? 24}>
            <Collapse size="small" items={[{
                key: props.client.id,
                label: <Custom.ClientInfo client={props.client} size={24}/>,
                extra: props?.editable && <Checkbox defaultChecked={props?.checked} onChange={handleCheckboxChange}/>,
                children: <>
                    <Custom.HiddenItem name={[props?.index ?? 0, 'id']} initialValue={props?.client?.id}/>
                    {config[props?.client?.id] ? config[props?.client?.id]({
                        editable: props.editable,
                        client: props.client,
                        form: props.form,
                        config: props.config,
                        index: props?.index
                    }) : translate('client.noConfig')}
                </>
            }]}/>
        </Col>
    )
}
